export default {
  storefront_not_found: {
    title: 'Geen storefront gevonden',
    description: 'Maak een storefront aan.',
  },
};
